import { IOptions } from '../entities/processing/processing-preset-settings.model';

export const EmptyOption: IOptions = {
  title: '---',
  value: 0,
};
